module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-sidebar",
    class: {
      '-is-collapse-menu-active': _vm.collapseMenu
    }
  }, [_c('el-menu', {
    attrs: {
      "default-active": _vm.activeIndex,
      "router": true,
      "collapse": _vm.collapseMenu,
      "background-color": "#222d32",
      "text-color": "#fff"
    }
  }, [_vm._l((_vm.menu), function(item) {
    return (item.children.length === 0 && item.permission) ? _c('el-menu-item', {
      attrs: {
        "route": {
          name: item.domain + '.index'
        },
        "index": item.domain + '.index',
        "title": item.name
      }
    }, [_c('i', {
      class: item.icon
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.name))])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.menu), function(item) {
    return (item.children.length > 0 && item.permission) ? _c('el-submenu', {
      attrs: {
        "index": item.domain
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.icon
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _vm._l((item.children), function(child) {
      return (child.permission) ? _c('el-menu-item', {
        attrs: {
          "route": {
            name: child.domain + '.index'
          },
          "index": child.domain + '.index',
          "title": child.name
        }
      }, [_c('i', {
        class: child.icon
      }), _vm._v(" "), _c('span', [_vm._v(_vm._s(child.name))])]) : _vm._e()
    })], 2) : _vm._e()
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-369c14cc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/main/Sidebar.vue
// module id = 739
// module chunks = 2